function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { saveProgramApi, putProgramApi, getProgramInfoApi } from '@/api/program';
import debounce from '@form-create/utils/lib/debounce';
import { customerSelectApi, selectContractListApi } from '@/api/enterprise';
import { deleteProgramApi } from '@/api/program';
export default {
  name: 'addProgram',
  components: {
    selectMember: function selectMember() {
      return import('@/components/form-common/select-member');
    },
    detailsProgram: function detailsProgram() {
      return import('../components/detailsProgram');
    }
  },
  props: {
    type: {
      type: String,
      default: 'info'
    },
    customer: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    formInfo: {
      type: Object,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      drawer: false,
      loading: false,
      id: 0,
      drawerType: this.type,
      contractList: [],
      customerList: [],
      userList: [],
      principal: [],
      departType: 0,
      memberShow: false,
      onlyOne: false,
      edit: false,
      formData: {
        status: 0,
        cid: 0
      },
      detailsData: {},
      rule: {
        name: [{
          required: true,
          message: '请输入项目名称',
          trigger: 'blur'
        }],
        uid: [{
          required: true,
          message: '请选择负责人',
          trigger: 'blur'
        }],
        end_date: [{
          required: false,
          message: '请选择项目计划结束日期',
          trigger: 'blur'
        }, {
          validator: this.checkEndDate,
          trigger: 'change' // 当结束日期变化时触发校验
        }]
      }
    };
  },
  mounted: function mounted() {
    if (this.formInfo && this.formInfo.id) {
      this.formData = this.formInfo;
      this.getCustomer();
      if (this.formData.eid) {
        this.getContract(this.formData.eid);
      }
      this.userList = this.formData.members;
      this.id = this.formData.id;
      this.principal = this.formData.admins;
      this.formData.eid = this.formData.eid != 0 ? this.formData.eid : '';
      this.formData.cid = this.formData.cid != 0 ? this.formData.cid : '';
    } else {
      this.customerList = this.customer;
    }
  },
  methods: {
    checkEndDate: function checkEndDate(rule, value, callback) {
      if (value && this.formData.start_date) {
        if (value < this.formData.start_date) {
          callback(new Error('结束日期不能早于开始日期'));
        } else {
          callback();
        }
      } else {
        callback();
      }
    },
    drawerEdit: function drawerEdit(type) {
      this.drawerType = type;
    },
    // 获取客户数据
    getCustomer: function getCustomer() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var result;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return customerSelectApi();
            case 2:
              result = _context.sent;
              _this.customerList = result.data;
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    // 获取合同数据
    getContract: function getContract(eid) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var result;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return selectContractListApi({
                data: eid
              });
            case 2:
              result = _context2.sent;
              _this2.contractList = result.data;
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    // 删除项目
    handleDelete: function handleDelete() {
      var _this3 = this;
      this.$modalSure('确定删除此项目').then(function () {
        deleteProgramApi(_this3.id).then(function (res) {
          if (res.status == 200) {
            _this3.$emit('goBack');
          }
        });
      });
    },
    // 选择客户
    handleContract: function handleContract(eid) {
      this.formData.cid = '';
      this.getContract(eid);
      // this.$emit('getContractList', eid)
    },
    // 选择成员回调
    getSelectList: function getSelectList(data, type) {
      if (type === 1) {
        this.formData.uid = data[0].value;
        this.principal = data;
        this.formData.admins = data;
      } else if (type === 2) {
        var checkUid = [];
        data.forEach(function (item) {
          checkUid.push(item.value);
        });
        this.formData.members = checkUid;
        this.userList = data;
      }
    },
    // 获取项目详情
    getProgramInfo: function getProgramInfo(id) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var result;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return getProgramInfoApi(id);
            case 2:
              result = _context3.sent;
              _this4.formData = result.data;
              _this4.detailsData = result.data;
              _this4.userList = result.data.members;
              _this4.principal = result.data.admins;
              _this4.formData.eid = result.data.eid != 0 ? result.data.eid : '';
              _this4.formData.cid = result.data.cid != 0 ? result.data.cid : '';
              _this4.$emit('getContractList', _this4.formData.eid);
            case 10:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    // 删除标签
    cardTag: function cardTag(type, index) {
      if (type === 1) {
        this.principal.splice(index, 1);
        this.formData.uid = '';
      } else {
        this.userList.splice(index, 1);
        this.formData.members.splice(index, 1);
      }
    },
    handleClose: function handleClose() {
      this.reset();
      if (this.drawerType !== 'info') {
        this.$refs.formData.resetFields();
      }
      this.$emit('handleClose');
    },
    openBox: function openBox(id, type) {
      this.drawerType = type;
      this.drawer = true;
      this.id = id ? id : 0;
      if (this.drawerType) {
        // this.getProgramInfo(id)
      }
    },
    reset: function reset() {
      this.formData = {
        name: '',
        uid: '',
        eid: '',
        cid: '',
        members: [],
        admins: [],
        contract: {},
        customer: {},
        start_date: '',
        end_date: '',
        status: 0,
        describe: ''
      };
      // this.edit = false
      this.userList = [];
      this.principal = [];
    },
    // 提交
    handleConfirm: debounce(function () {
      var _this5 = this;
      this.$refs.formData.validate(function (valid) {
        if (valid) {
          _this5.loading = true;
          if (_this5.drawerType == 'edit' && _this5.id > 0) {
            var members = [];
            members = _this5.userList.map(function (item) {
              return item.value ? item.value : item.id;
            });
            _this5.formData.members = members;
            if (_this5.formData.name.trim()) {
              putProgramApi(_this5.id, _this5.formData).then(function (res) {
                if (res.status == '200') {
                  _this5.drawerType = 'info';
                  _this5.getProgramInfo(_this5.id);
                }
                _this5.loading = false;
              });
            } else {
              _this5.$message('项目名称不能为空');
            }
          } else {
            if (_this5.formData.name.trim()) {
              saveProgramApi(_this5.formData).then(function (res) {
                if (res.status == 200) {
                  _this5.reset();
                  _this5.formData = {};
                  _this5.$emit('getTableData', {}, 1);
                  _this5.$refs.formData.clearValidate();
                }
                _this5.loading = false;
              });
            } else {
              _this5.$message('项目名称不能为空');
            }
          }
        }
      });
    }, 500),
    addRow: function addRow() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _this6.drawerType = '';
              _this6.reset();
            case 2:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    editRow: function editRow() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _this7.drawerType = 'edit';
            case 1:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    deleteRow: function deleteRow() {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var row;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              row = {
                id: _this8.id
              };
              _this8.$emit('handleDelete', row);
            case 2:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    }
  }
};